var map = {
	"./label-10A4.jpeg": "a5e1",
	"./label-10DUPLO.jpeg": "ec34",
	"./label-11SIMPLE.jpeg": "0f9c",
	"./label-1A4.jpeg": "1fc4",
	"./label-1DUPLO.jpeg": "0b79",
	"./label-1TRIPLA.jpeg": "cf6f",
	"./label-2A4.jpeg": "93ac",
	"./label-2DUPLO.jpeg": "8bea",
	"./label-2SIMPLE.jpeg": "4c7a",
	"./label-3A4.jpeg": "c4ca",
	"./label-4DUPLO.jpeg": "50a1",
	"./label-5A4.jpeg": "1c52",
	"./label-5DUPLO.jpeg": "df25",
	"./label-6SIMPLE.jpeg": "be6a",
	"./label-8SIMPLE.jpeg": "e1f6",
	"./label-9SIMPLE.jpeg": "5520"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3c9";